<div class="featured-container">
  <app-header></app-header>

  <main class="featured-content">
    <section class="page-hero">
      <div class="hero-content">
        <h1 class="page-title">Featured Listings</h1>
        <p class="page-description">
          Discover premium listings that have been specially highlighted for
          maximum visibility.
        </p>
      </div>
    </section>

    <section class="filters-section">
      <div class="filters-container">
        <div class="filters-row">
          <div class="filter-group">
            <label class="filter-label">Category</label>
            <select
              class="filter-select"
              [(ngModel)]="selectedCategory"
              (change)="onCategoryChange()"
            >
              <option
                *ngFor="let category of categories"
                [value]="category.value"
              >
                {{ category.label }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label">Sort By</label>
            <select
              class="filter-select"
              [(ngModel)]="selectedSort"
              (change)="onSortChange()"
            >
              <option *ngFor="let sort of sortOptions" [value]="sort.value">
                {{ sort.label }}
              </option>
            </select>
          </div>

          <div class="filter-group">
            <label class="filter-label">Min Price</label>
            <input
              type="number"
              class="filter-input"
              placeholder="0"
              [(ngModel)]="filters.price_min"
              (blur)="onPriceFilterChange()"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">Max Price</label>
            <input
              type="number"
              class="filter-input"
              placeholder="Any"
              [(ngModel)]="filters.price_max"
              (blur)="onPriceFilterChange()"
            />
          </div>

          <button class="clear-filters-btn" (click)="clearFilters()">
            Clear All
          </button>
        </div>
      </div>
    </section>

    <section class="results-section">
      <div class="results-container">
        <div class="results-header">
          <h2 class="results-title">
            Featured Listings
            <span class="results-count" *ngIf="!isLoading">
              ({{ totalListings }} results)
            </span>
          </h2>
        </div>

        <div *ngIf="isLoading" class="listings-grid">
          <div
            class="listing-card loading-placeholder"
            *ngFor="let i of [1, 2, 3, 4, 5, 6]"
          >
            <div class="listing-image-placeholder"></div>
            <div class="listing-content">
              <div class="loading-line loading-title"></div>
              <div class="loading-line loading-category"></div>
              <div class="loading-line loading-description"></div>
              <div class="loading-line loading-price"></div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading && listings.length > 0" class="listings-grid">
          <article
            *ngFor="let listing of listings"
            class="listing-card"
            (mouseenter)="onListingHover(listing)"
            (mouseleave)="onListingLeave(listing)"
          >
            <div
              class="listing-image-container"
              (touchstart)="onTouchStart($event, listing)"
              (touchmove)="onTouchMove($event, listing)"
              (touchend)="onTouchEnd($event, listing)"
            >
              <div
                class="image-wrapper"
                [class.loading]="listing.isImageLoading"
              >
                <img
                  [src]="listing.image"
                  [alt]="listing.title"
                  class="listing-image"
                  loading="lazy"
                  (load)="onImageLoad(listing.image, listing)"
                  (error)="
                    listing.image =
                      '/assets/images/listing-placeholder/no-image-placeholder.png'
                  "
                />

                <div
                  class="image-loading-overlay"
                  *ngIf="listing.isImageLoading"
                >
                  <div class="spinner"></div>
                </div>

                <div class="image-overlay"></div>
              </div>

              <div
                class="image-click-zones desktop-only"
                *ngIf="hasMultipleImages(listing)"
              >
                <div
                  class="click-zone zone-left"
                  (click)="onImageZoneClick($event, listing, 'prev')"
                  [attr.aria-label]="'Previous image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </div>
                </div>
                <div
                  class="click-zone zone-middle"
                  (click)="onImageZoneClick($event, listing, 'view')"
                ></div>
                <div
                  class="click-zone zone-right"
                  (click)="onImageZoneClick($event, listing, 'next')"
                  [attr.aria-label]="'Next image'"
                >
                  <div class="zone-icon">
                    <svg viewBox="0 0 24 24" class="zone-svg">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </div>
              </div>

              <div
                class="carousel-controls desktop-only"
                *ngIf="
                  hasMultipleImages(listing) && listing.showCarouselControls
                "
                [class.fading-out]="!listing.showCarouselControls"
              >
                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </div>

                <div class="carousel-indicator">
                  <svg viewBox="0 0 24 24" class="carousel-icon">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </div>
              </div>

              <div
                class="image-counter desktop-only"
                *ngIf="hasMultipleImages(listing)"
              >
                {{ getImageCounter(listing) }}
              </div>

              <div
                class="image-dots mobile-only"
                *ngIf="hasMultipleImages(listing)"
              >
                <span
                  *ngFor="let img of listing.images; let i = index"
                  class="dot"
                  [class.active]="i === listing.currentImageIndex"
                ></span>
              </div>

              <div class="listing-badges">
                <div class="listing-badge featured">Featured</div>
                <div *ngIf="listing.new" class="listing-badge new">New</div>
              </div>

              <div class="listing-bookmark" (click)="$event.stopPropagation()">
                <app-wishlist-heart
                  [listingId]="listing.id.toString()"
                  [tableName]="listing.table_name || ''"
                  *ngIf="
                    listing.table_name && shouldShowWishlistButton(listing)
                  "
                ></app-wishlist-heart>
              </div>
            </div>

            <div class="listing-content" (click)="onListingClick(listing)">
              <div class="listing-main-info">
                <div class="listing-header">
                  <h3 class="listing-title">{{ listing.title }}</h3>
                </div>
                <div class="listing-price-wrapper">
                  <div class="listing-price">
                    <span *ngIf="listing.price > 0">
                      <span class="price-currency">{{
                        listing.currency || "€"
                      }}</span>
                      <span class="price-value">{{
                        listing.price | number : "1.0-0"
                      }}</span>
                    </span>
                    <span *ngIf="listing.price === 0" class="price-free">
                      Free
                    </span>
                  </div>
                </div>
                <div class="listing-details-grid">
                  <div class="listing-location" *ngIf="listing.location">
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                      ></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ listing.location }}</span>
                  </div>

                  <div
                    class="listing-views"
                    *ngIf="listing.view_count && listing.view_count > 0"
                  >
                    <svg viewBox="0 0 24 24" class="detail-icon">
                      <path
                        d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                      ></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span>{{ listing.view_count }} views</span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>

        <div *ngIf="!isLoading && listings.length === 0" class="empty-state">
          <div class="empty-icon">
            <svg viewBox="0 0 24 24" class="empty-svg">
              <path d="M5 12l2-7 5 5 5-5 2 7H5z"></path>
              <path d="M5 12v7h14v-7"></path>
            </svg>
          </div>
          <h3 class="empty-title">No Featured Listings Found</h3>
          <p class="empty-description">
            There are no featured listings matching your criteria at the moment.
            Try adjusting your filters or check back later.
          </p>
          <button class="empty-action-btn" (click)="clearFilters()">
            Clear Filters
          </button>
        </div>

        <div
          *ngIf="!isLoading && listings.length > 0 && totalPages > 1"
          class="pagination"
        >
          <button
            class="pagination-btn"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
          >
            Previous
          </button>

          <button
            *ngFor="let page of getVisiblePages()"
            class="pagination-btn"
            [class.active]="page === currentPage"
            (click)="onPageChange(page)"
          >
            {{ page }}
          </button>

          <button
            class="pagination-btn"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
          >
            Next
          </button>
        </div>
      </div>
    </section>
  </main>

  <app-footer></app-footer>
</div>
